// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JtgQg","buttona":"Button_buttona__Cii0f","white":"Button_white__FV8SW","addStyle":"Button_addStyle__JPIGs"};